import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IdName } from 'src/app/shared/models/id-name';
import { ICompetenceMatrixUser } from '../competence-matrix.model';

@Component({
  selector: 'app-send-competence-matrix-notifications-dialog',
  templateUrl: './send-competence-matrix-notifications-dialog.component.html',
  styleUrls: ['./send-competence-matrix-notifications-dialog.component.scss'],
  standalone: false,
})
export class SendCompetenceMatrixNotificationsDialogComponent implements OnInit {
  users: IdName[] = [];
  userIds = new FormControl([]);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { users: ICompetenceMatrixUser[] },
    public dialogRef: MatDialogRef<SendCompetenceMatrixNotificationsDialogComponent>
  ) {}

  ngOnInit(): void {
    this.users = this.data.users.map((u) => ({ id: u.userId, name: u.fullName }));
  }

  submit(): void {
    this.dialogRef.close({
      userIds: this.userIds.value,
    });
  }
}
